module.exports = "/shared/img/video-roulette.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/video-roulette.png
// module id = 457
// module chunks = 13